export default class Dialog {
	constructor(def) {
		this._id = 0; // 弹窗ID
		this._default = def; // 默认弹窗组件
		this.data = [];
	}
	remove(msg) {
		var idx = this.data.indexOf(msg);
		if (idx >= 0) {
			this.data.splice(idx, 1);
		}
	}
	push(item) {
		let waitClose = new Promise((resolve) => (item.onclose = resolve));
		let close = (e) => {
			item.onclose(e);
			this.remove(item);
		};
		item.close = close;
		item.id = ++this._id;
		this.data.push(item);
		waitClose.close = close;
		return waitClose;
	}
	show(component, transition, props) {
		if (typeof transition === "object") {
			props = transition;
			transition = "";
		}
		return this.push({component, transition, props});
	}
}
